// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___2UwHF","upper":"styles__upper___3SBNP","icon":"styles__icon___2Fy1G","footer":"styles__footer___2FI9V"};